import { z } from 'zod';

export const myLQAPlanCreateSchema = z.object({
	name: z
		.string()
		.nonempty('Name is required')
		.min(1)
		.max(100, 'Name cannot exceed 100 characters'),
	headline: z
		.string()
		.max(500, 'Plan description cannot exceed 500 characters')
		.nullable(),
	features: z
		.array(z.string().max(255, 'Feature cannot exceed 255 characters'))
		.transform((features) => features.filter((f) => f.trim() !== '')),
});

export const myLQAPlanUpdateSchema = myLQAPlanCreateSchema
	.partial()
	.merge(z.object({ position: z.number().optional() }));
